import { Box, Button, Modal, ThemeProvider, createTheme } from "@mui/material";
import React, { useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import ReactImagePickerEditor, {
  ImagePickerConf,
} from "react-image-uploader-fa";
import "react-image-uploader-fa/dist/index.css";
import DropzoneByClick from "./DropzoneByClick";
import dataURLtoFile from "../../utility/dataURLtoFile";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CloseIcon from "@mui/icons-material/Close";
import { MuiThemeProvider } from "@material-ui/core";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { useSelector } from "react-redux";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";

const config: ImagePickerConf = {
  borderRadius: "5px",
  language: "fa",
  width: "35vw",
  height: "20rem",
  objectFit: "contain",
  compressInitial: null,
  widthOfImageContainer: "35vw",
};

const initialImage = "";
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1800,
    },
  },
});

const style = (theme: any) => ({
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  [theme.breakpoints.up("xl")]: {
    // backgroundColor: "red",
    width: "60%",
    height: "80%",
  },
  [theme.breakpoints.between("lg", "xl")]: {
    // backgroundColor: "blue",
    width: "85%",
    height: "80%",
  },
  [theme.breakpoints.between("md", "lg")]: {
    // backgroundColor: "yellow",
    width: "80%",
    height: "80%",
  },
  [theme.breakpoints.down("md")]: {
    // backgroundColor: "green",
    width: "80%",
    height: "80%",
  },
  bgcolor: "white",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  overflow: "hidden",
  paddingRight: "3vh",
  paddingTop: "5vh",
  direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
});
let mainColor: any;
export default function ImageEditorCmp({
  handleImageSubmit = () => {},
  paddingRight,
  size,
  picName,
  circleButtonColor = "#01AF43",
  picCount,
  marginTop,
  validation,
  hasValue,
  chequeTopView,
  isChequeInfo = false,
  width,
  logo,
  fileTitle,
  fileName,
  height,
  minHeight,
  paddingBottom,
}: {
  handleImageSubmit?: Function;
  paddingRight?: String;
  size?: number;
  picName?: String;
  circleButtonColor?: String;
  picCount?: string;
  marginTop?: string;
  validation?: any;
  hasValue?: any;
  chequeTopView?: boolean;
  isChequeInfo?: boolean;
  width?: object | string;
  logo?: string;
  fileTitle?: string;
  fileName?: string;
  height?: string;
  minHeight?: string;
  paddingBottom?: string;
}) {
  const jsonFile = useSelector((state: any) => state.style);

  mainColor = jsonFile?.mainColor;
  const [imageSrc, setImageSrc] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [openImageUploade, setOpenImageUploade] = useState(false);
  const [openFileUploade, setOpenFileUploade] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [showBtn, setShowBtn] = useState(true);
  const [imageSelect, setImageSelect] = useState(false);
  const inputRef = useRef<any>(null);

  const handleCloseModal = () => {
    setOpenModal(false);
    setOpenFileUploade(false);
    setOpenImageUploade(false);
    setEditMode(false);
    setShowBtn(true);
    setImageSelect(false);
  };

  const handlOpenModal = () => {
    setOpenModal(true);
  };

  const handleAddCircleBtn = () => {
    handlOpenModal();

    if (inputRef !== null) {
      setTimeout(() => {
        inputRef?.current.click();
      }, 100);
      setOpenImageUploade(true);
    }
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <Grid
          container
          style={{
            paddingLeft: "10vh !important",
            paddingBottom: `${paddingBottom ? paddingBottom : "5vh"}`,
            paddingRight: `${paddingRight}`,
            justifyContent: "center",
            marginTop: `${marginTop}`,
          }}
          sx={{ width: `${width}` }}
        >
          <Grid
            item
            xs={size}
            style={{ height: `${height}`, minHeight: `${minHeight}` }}
            className={`${
              picCount == "two"
                ? "dropzoneUploadImageTwoImg "
                : "dropzoneUploadImage"
            }`}
          >
            <div
              className={minHeight ? "borderUploadLogo" : "borderUploadImage"}
              style={{
                minHeight: minHeight ? minHeight : "16vh",
                cursor: "pointer",
                marginRight: "0px",
                marginLeft: "1rem",
                marginBottom: "1 .3rem",
                maxWidth: "",
                minWidth: "90%",
              }}
              onClick={handleAddCircleBtn}
            >
              <div
                className="fileuploader-modal-container"
                style={{ paddingTop: "5.5vh", marginTop: "-1.2vh" }}
              >
                {logo === "StorefrontIcon" ? (
                  <StorefrontIcon
                    style={{
                      color: `${jsonFile?.secondColor_200}`,
                      width: "30px",
                      height: "30px",
                      cursor: "pointer",
                    }}
                    className="imageuploader-editor"
                  />
                ) : (
                  <AddPhotoAlternateOutlinedIcon
                    style={{
                      color: `${jsonFile?.secondColor_200}`,
                      width: "30px",
                      height: "30px",
                      cursor: "pointer",
                    }}
                    className="imageuploader-editor"
                  />
                )}
                <br />
                <p
                  className="classCenter secondColor_200"
                  style={{
                    marginTop: "3vh",
                    fontSize: "1rem",
                    fontWeight: "bold",
                  }}
                >
                  {fileTitle ? (
                    fileTitle
                  ) : (
                    <>بارگذاری &nbsp;{fileName ? fileName : "فایل"}</>
                  )}
                </p>
                {/* <InsertPhotoIcon className="dropzoneUploadIcon" />
                <span className="classCenter uploadImageTitle">{picName}</span> */}
              </div>
            </div>
          </Grid>
        </Grid>
        <div>
          <Modal
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={[style]}>
              <Box position={"relative"}>
                <Typography
                  onClick={handleCloseModal}
                  component={"p"}
                  color={"#E6123D"}
                  position={"absolute"}
                  top={"-30px"}
                  left={0}
                  sx={{ cursor: "pointer" }}
                  fontSize={"20px"}
                >
                  <CloseIcon></CloseIcon>
                </Typography>
              </Box>
              <Box className="fileuploader-modal-container">
                <Grid
                  container
                  direction="column"
                  justifyContent={"center"}
                  alignItems={"center"}
                  // width={"40%"}
                  // paddingBottom={"2rem"}
                  bgcolor={"#fff"}
                  marginX={"auto"}
                  height={"100%"}
                  // marginTop={"9rem"}
                  // sx={[
                  //   showBtn && {
                  //     display: "none",
                  //   },
                  // ]}
                >
                  <Grid item className="fileuploader-modal-container">
                    <Box
                      // sx={[!openImageUploade && { display: "none" }]}
                      className={!editMode ? "imageuploader-editor" : ""}
                    >
                      <Box
                        sx={{
                          backgroundColor: "#F1F4FF",
                          borderRadius: "5px",
                          width: "100%",
                          paddingY: "1rem",
                          paddingX: "1.5rem",
                          marginBottom: "2rem",
                          // maxWidth: "600px !important",
                        }}
                      >
                        <Typography
                          color={"#1D4A87"}
                          fontSize={"14px"}
                          marginBottom={"0.7rem"}
                          sx={{ direction: "rtl" }}
                        >
                          <span>
                            <WarningAmberIcon
                              sx={{ marginLeft: "0.5rem" }}
                            ></WarningAmberIcon>
                          </span>
                          در صورت وجود حاشیه در اطراف محتوای اصلی، تصویر را
                          ویرایش و سپس ارسال نمایید.
                        </Typography>
                      </Box>
                      <ReactImagePickerEditor
                        config={config}
                        imageSrcProp={initialImage}
                        imageChanged={(newDataUri: any) => {
                          setImageSrc(newDataUri);
                        }}
                        imageDownloaded={(e: any) => {
                          handleImageSubmit(
                            dataURLtoFile(e.imageSrc, e.imageTitle)
                          );
                          handleCloseModal();
                        }}
                        imagePanelOpen={() => {
                          setEditMode(true);
                          setImageSelect(true);
                        }}
                        imagePanelClose={() => {
                          setEditMode(false);
                        }}
                        imageSelected={() => setImageSelect(true)}
                        inputRef={inputRef}
                        imageDeleted={() => setImageSelect(false)}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Modal>
        </div>
      </ThemeProvider>
    </>
  );
}
